<template>
  <div v-loading="$store.getters.getLoadingState">
      <div v-if="!plannerSource" style="width: 100%; text-align: right;">
          <el-popconfirm
            @confirm="notifyCustomerReadyItems"
            title="Are you sure to notify?"
            >
            <el-button slot="reference" type="primary" size="small">Notify This Customer</el-button>
        </el-popconfirm>
      </div>
      <div v-if="plannerSource">
            <div style="display: flex; flex-direction: row; width: 100%;">
                <span type="label" style="margin-top: 5px;">Change Scheduled Date</span>
                <el-date-picker
                    size="small"
                    type="date"
                    style="width: 200px; margin-left: 20px;"
                    v-model="appointment_date"
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker> 
                
                <el-button :disabled="getFinalList.filter(t => t.selected).length === 0" @click="updateAllPromise" size="small" type="primary" style="margin-left: 10px;">
                    Submit
                </el-button>
            </div>
            <br>
      </div>
      <div style="font-size: 12px;">
        <el-table
            :data="getFinalList"
            style="width: 100%">
        
        <el-table-column
            v-if="plannerSource"
            width="40">
            <template slot="header" slot-scope="scope">
                <el-checkbox
                @change="selectAllRows"
                v-model="selectAll"
                size="mini"/>
                {{scope.row}}
            </template>
            <template slot-scope="scope">
                <el-checkbox
                v-model="scope.row.selected"
                size="mini"/>
            </template>

            </el-table-column>
          <el-table-column 
            label="#">
            <template slot-scope="scope">
                <span class="rowFontSize">
                    {{scope.row.sale_number}}-{{scope.row.sl_no}}-{{scope.row.qty_sl_no}}{{scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''}}
                    <a 
                        title="Add Task"
                        @click="$emit('addTask', {title: scope.row.sale_number+'-'+scope.row.sl_no+'-'+scope.row.qty_sl_no+''+(scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''), description: scope.row.customer_name})" 
                        style="cursor: pointer;">
                        <i :class="'el-icon-date'"></i>
                    </a>
                </span>
            </template>
          </el-table-column>

          <el-table-column 
            sortable
            prop="template_name"
            label="Garment Name">
            <template slot-scope="scope">
                <span class="rowFontSize">
                    {{scope.row.template_name}}                        
                </span>                
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="schedule_date"
            label="Scheduled Date" width="150" v-if="plannerSource">
            <template slot-scope="scope">
                <el-popover
                    placement="right"
                    width="400"
                    content="Loading..."
                    trigger="click">
                        <br>
                    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                        <span>
                           <b>{{scope.row.sale_number}}-{{scope.row.sl_no}}-{{scope.row.qty_sl_no}}{{scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''}}</b>
                        </span>
                        
                        <div style="margin-top: 20px;">
                            <span type="label">Change Scheduled Date</span>
                            <br>
                            <el-date-picker
                                size="small"
                                type="date"
                                style="width: 350px;"
                                v-model="scope.row.appointment_date"
                                value-format="yyyy-MM-dd"
                                format="MMM dd yyyy">
                            </el-date-picker> 
                        </div>
                        <div style="margin-top: 10px;">
                            <span type="label">Remarks</span>
                            <br>
                            <el-input @focus="$event.target.select()"
                                placeholder="Remarks"
                                size="small"
                                clearable
                                style="width: 350px; text-align: left;"
                                v-model="scope.row.schedule_notes"
                                @keyup.enter.native="updateScheduledDate(scope.row)">
                            </el-input>
                        </div>
                        
                        <el-button @click="updateScheduledDate(scope.row)" size="small" :type="'primary'" style="margin-top: 10px;">
                            Save
                        </el-button>

                    </div>
                    <el-button slot="reference" size="small">
                        {{scope.row.appointment_date_changed}}
                        {{scope.row.appointment_type === 0 ? '(D)' : '(T)'}}
                    </el-button>
                </el-popover>
            </template>
          </el-table-column>

          <el-table-column 
            v-for="(data, index) in getMasterStageList"
            :key="index"
            :label="data.process_name" align="center">
                <template slot-scope="scope">
                    
                    <div v-if="scope.row[data.process_name] !== undefined && scope.row[data.process_name].is_required === 1">

                        <el-tooltip class="item" effect="light">
                            <div slot="content" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                                <span style="font-size: 18px;">
                                    <b>Completed</b>
                                </span>
                                <br>
                                <span>
                                    <b>Staff Name:</b> {{scope.row[data.process_name].staff_name}}
                                </span>
                                <span>
                                    <b>Started At:</b> {{scope.row[data.process_name].started_at}} 
                                </span>
                                <span>
                                    <b>Finished At:</b> {{scope.row[data.process_name].finished_at}} 
                                </span>
                            </div>
                            <el-tag type="success" v-if="scope.row[data.process_name].work_staus === 4">
                                <i class="el-icon-success"></i>
                            </el-tag>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="Waiting">                            
                            <el-tag type="warning" v-if="scope.row[data.process_name].work_staus === 0">
                                <i class="el-icon-watch"></i>
                            </el-tag>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="Waiting">                            
                            <div slot="content" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                                <span style="font-size: 18px;">
                                    <b>In Progress</b>
                                </span>
                                <br>
                                <span>
                                    <b>Staff Name:</b> {{scope.row[data.process_name].staff_name}}
                                </span>
                                <span>
                                    <b>Started At:</b> {{scope.row[data.process_name].started_at}} 
                                </span>
                                <span>
                                    <b>Finished At:</b> -
                                </span>
                            </div>
                            <el-tag type="info" v-if="scope.row[data.process_name].work_staus === 1">
                                <i class="el-icon-timer"></i>
                            </el-tag>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light">
                            <div slot="content" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                                <span style="font-size: 18px;">
                                    <b>Pending Approval</b>
                                </span>
                                <br>
                                <span>
                                    <b>Staff Name:</b> {{scope.row[data.process_name].staff_name}}
                                </span>
                                <span>
                                    <b>Started At:</b> {{scope.row[data.process_name].started_at}} 
                                </span>
                                <span>
                                    <b>Finished At:</b> {{scope.row[data.process_name].finished_at}} 
                                </span>
                            </div>
                            <el-tag v-if="scope.row[data.process_name].work_staus === 2">
                                <i class="el-icon-time"></i>
                            </el-tag>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light">
                            <div slot="content" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                                <span style="font-size: 18px;">
                                    <b>Work Rejected</b>
                                </span>
                                <br>
                                <span>
                                    <b>Staff Name:</b> {{scope.row[data.process_name].staff_name}}
                                </span>
                                <span>
                                    <b>Started At:</b> {{scope.row[data.process_name].started_at}} 
                                </span>
                                <span>
                                    <b>Finished At:</b> {{scope.row[data.process_name].finished_at}} 
                                </span>
                            </div>
                            <el-tag type="danger" v-if="scope.row[data.process_name].work_staus === 3">
                                <i class="el-icon-circle-close"></i>
                            </el-tag>
                        </el-tooltip>
                    </div>
                    <span v-else title="Not available">
                        <i class="el-icon-close"></i>
                    </span>
                   
                </template>                
          </el-table-column>

        </el-table>
        </div>
        
  </div>
</template>

<script>
export default {
    props: ['customer_id', 'plannerSource', 'searchType'],
    data() {
        return {
            appointment_date: new Date(),
            selectAll: false,
        }
    },
    computed: {
        getDataList() {
            return this.$store.state.production.ready_order_detail_list
        },
        getMasterStageList() {
            return this.$store.getters.getProductionStageList
        },
        getFinalList() {
            let returnList = []

            this.getDataList.forEach(element => {
                
                let newElement = {
                    id: element.id,
                    current_store_id: element.current_store_id,
                    customer_name: element.customer_name,
                    work_order_id: element.work_order_id,
                    work_order_number: element.work_order_number,
                    sale_id: element.sale_id,
                    sale_number: element.sale_number,
                    sl_no: element.sl_no,
                    qty_sl_no: element.qty_sl_no,
                    template_name: element.sub_template_name !== null ? element.sub_template_name : element.template_name,
                    appointment_date: element.appointment_date,
                    appointment_date_changed: element.appointment_date_changed,
                    schedule_notes: element.schedule_notes,
                    appointment_type: element.appointment_type,
                    selected: element.selected,
                    priority: {
                        added_to_priority: element.added_to_priority === 1,
                        priority_date: element.priority_date,
                        priority_notes: element.priority_notes,
                        priority_number: element.priority_number
                    }
                }

                this.getMasterStageList.forEach(stage => {
                    let stageFilter = element.required_stages.filter(t => t.process_id === stage.id)
                    if(stageFilter.length>0) {
                        let workLog = stageFilter[0].work_log
                        
                        let node = stage.process_name
                        let obj1 = newElement

                        let workStatus = 0
                        if(workLog.work_status) {
                            workStatus = workLog.work_status
                        }
                        if(workLog.hidden_process) {
                            if(workLog.hidden_process >=0 && stageFilter[0].is_required) {
                                workStatus = 4
                            }
                        }
                        
                        obj1[node] = {
                            id: stage.id,
                            is_required: stageFilter[0].is_required,
                            work_staus: workStatus,
                            staff_name: workLog.staff_name ? workLog.staff_name : '',
                            started_at: workLog.started_at_changed_time ? workLog.started_at_changed_time : '',
                            finished_at: workLog.finished_at_changed_time ? workLog.finished_at_changed_time : ''
                        }
                    }
                })
                
                returnList.push(newElement)
            })

            if(this.searchType && this.searchType === 2) {
                return returnList.filter(t => t.priority.added_to_priority)
            }
            return returnList
        }
    },
    methods: {
        notifyCustomerReadyItems() {
            this.$store.dispatch('notifyCustomerForReadyItems', {
                customer_id_list: [this.customer_id]
            })
        },
        updateScheduledDate(rowData, show_detail = true) {
            
            this.$store.dispatch('updateScheduledDate', 
                {id: rowData.id, 
                work_order_id: rowData.work_order_id,
                sale_id: rowData.sale_id, 
                customer_id: this.customer_id, 
                schedule_notes: rowData.schedule_notes, 
                appointment_date: rowData.appointment_date,
                show_detail,
                plannerSource: this.plannerSource ? true : false})

            setTimeout(() => {
                this.$emit('closed')
            }, 1000);
        },
        updateAllPromise() {
            let key = 0
            let filterList = this.getFinalList.filter(t => t.selected)
            filterList.forEach(element => {
                element.appointment_date = this.appointment_date
                this.updateScheduledDate(element, key === (filterList.length-1))
                setTimeout(() => {
                    
                }, 500);
                key ++
            })

            this.$emit('closed')
        },
        updatePriority(rowData) {
            this.$store.dispatch('updatePriority', 
                {id: rowData.id, priority: rowData.priority})
        },
        selectAllRows() {
            if(this.selectAll) {
                this.$store.state.production.ready_order_detail_list.forEach(element => {
                    element.selected = true
                })
            } else {
                this.$store.state.production.ready_order_detail_list.forEach(element => {
                    element.selected = false
                })
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/ReadyOrders/DetailList.vue